import { useNavigate } from "react-router-dom"
import { useAppSelector } from "../redux/store/hooks"
import { selectProfessionalAuthenticationState } from "../redux/ProfessionalAuthentication"

import {
  NAVIGATION_VIEW,
  NavigationPaths
} from "../navigation/NavigationController"

function MinimalWhiteTile() {
  const navigate = useNavigate()
  const authenticated = useAppSelector(selectProfessionalAuthenticationState)

  return (
    <div className="w-full flex mt-20 flex-col sm:flex-row space-y-10 sm:space-y-0">

      {/* Left "Button" (not registered yet) */}
      <div className="flex-1 flex items-center justify-center">
        <div
          onClick={() =>
            navigate(
              NavigationPaths[
                NAVIGATION_VIEW.PROFESSIONAL_HELP_VIEW_REGISTRATION
              ].path
            )
          }
          className="
            flex flex-col items-center justify-center
            w-[300px] h-[120px]
            rounded-xl 
            bg-red-100 hover:bg-red-200 
            cursor-pointer shadow 
            p-4
            text-center
            space-y-2
          "
        >
          <div className="font-semibold text-base">
            Ich habe mich noch nicht als Ärzt:in registriert.
          </div>
          <div className="text-sm">
            Bitte registrieren Sie sich nur, wenn Sie in der Interventionsgruppe sind.
          </div>
        </div>
      </div>

      {/* Right "Button" (already registered) */}
      <div className="flex-1 flex items-center justify-center">
        <div
          onClick={() => {
            if (authenticated) {
              navigate(NavigationPaths[NAVIGATION_VIEW.PROFESSIONAL_HELP_VIEW].path)
            } else {
              const targetPath = NavigationPaths[NAVIGATION_VIEW.PROFESSIONAL_HELP_VIEW].path;
              navigate(NavigationPaths[NAVIGATION_VIEW.SIGN_IN].path, { state: { from: targetPath } });

            }
          }}
          className="
            flex flex-col items-center justify-center
            w-[300px] h-[120px]
            rounded-xl
            bg-green-100 hover:bg-green-200
            cursor-pointer shadow
            p-4
            text-center
            space-y-2
          "
        >
          <div className="font-semibold text-base">
            Ich habe mich bereits als Ärzt:in registriert.
          </div>
        </div>
      </div>
    </div>
  )
}

export default MinimalWhiteTile
